var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sam-table-row row",class:{'hoverable': _vm.hoverable, 
'noBorder': _vm.noBorder, 
'align-items-center': _vm.headerRow,
'pt-0': _vm.headerRowNoSpace,
'desktopView': _vm.desktopView
},on:{"click":function($event){_vm.clickableRow ? _vm.rowAction() : {}}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }